import classnames from 'classnames';
import React, { FC } from 'react';
// 用于xx.react.svg居中对齐
interface IProps {
  className?: string;
  children: React.ReactNode;
}
export const Icon: FC<IProps> = (props: IProps) => {
  const { children, className } = props;
  return <>
    <span className={classnames('align-text-top leading-none', className)}>
      {children}
    </span>
  </>;
};
